document.addEventListener('DOMContentLoaded', () => {
    let input_element,
        inline_hints_element,
        file_inputs_containers = document.querySelectorAll('form li.file')

    file_inputs_containers.forEach(function (e) {
        inline_hints_element = e.querySelector('.inline-hints');
        if (inline_hints_element !== null) {
            input_element = e.querySelector('input');
            inline_hints_element.appendChild(input_element);
            input_element.classList.add('mt-10');
        }
    });
});
